import { render, staticRenderFns } from "./OfferPopOver.vue?vue&type=template&id=dd236b20"
import script from "./OfferPopOver.vue?vue&type=script&lang=js"
export * from "./OfferPopOver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd236b20')) {
      api.createRecord('dd236b20', component.options)
    } else {
      api.reload('dd236b20', component.options)
    }
    module.hot.accept("./OfferPopOver.vue?vue&type=template&id=dd236b20", function () {
      api.rerender('dd236b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/OfferPopOver.vue"
export default component.exports